var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "recharge" },
    [
      _c(
        "mt-loadmore",
        {
          ref: "loadmore",
          attrs: { "bottom-method": _vm.ChangeQueryRecord, autoFill: false }
        },
        [
          _c("div", { staticClass: "bg_color" }, [
            _c("div", { staticClass: "bg_head" }, [
              _c("div", { staticClass: "head_content" }, [
                _c("img", {
                  staticClass: "head_img",
                  attrs: { src: _vm.logoUrl }
                })
              ])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "money_num" }, [
              _vm._v("￥" + _vm._s(_vm.integral))
            ])
          ]),
          _vm._v(" "),
          _vm.dataList.length
            ? _c(
                "div",
                { staticClass: "mains" },
                _vm._l(_vm.dataList, function(item, index) {
                  return _c("div", { key: index, staticClass: "main_item" }, [
                    _c("div", { staticClass: "item_left" }, [
                      _c("div", { staticClass: "left_top" }, [
                        _vm._v(_vm._s(item.DSC))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "left_bottom" }, [
                        _vm._v(_vm._s(item.DAT))
                      ])
                    ]),
                    _vm._v(" "),
                    item.type == 2
                      ? _c("div", { staticClass: "item_right" }, [
                          _vm._v("-" + _vm._s(item.QTY) + "分")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    item.type == 1
                      ? _c("div", { staticClass: "item_right yellow" }, [
                          _vm._v(
                            "\n          +" + _vm._s(item.QTY) + "分\n        "
                          )
                        ])
                      : _vm._e()
                  ])
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.dataList.length == 0
            ? _c("div", { staticClass: "none_list" }, [
                _c("img", {
                  staticClass: "main_headimg",
                  attrs: { src: "/static/image/chongzhijilu.png" }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "main_text" }, [
                  _vm._v("还没有积分记录哦！")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "mint-loadmore-bottom",
              attrs: { slot: "bottom" },
              slot: "bottom"
            },
            [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.load,
                      expression: "load"
                    }
                  ]
                },
                [_vm._v("松手释放↑")]
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-584e7cb9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-584e7cb9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/integralDetail/index.vue
// module id = null
// module chunks = 